// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"

import LocalTime from "local-time"
LocalTime.start()

// Setup and configure the Trix editor and ActionText
import "trix"
import "@rails/actiontext"
import { configureTrixToolbar } from "./trix_toolbar_config"
configureTrixToolbar()
